module.exports = ".not_found_page {\r\n  width: 100%;\r\n  margin: 20% 0;\r\n}\r\n.card {\r\n  text-align: center;\r\n}\r\n"